var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConvenience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.365,
    height: 22.842,
    viewBox: "0 0 24.365 22.842",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.181,28.181a1.524,1.524,0,0,1-1.169-2.5l7.613-9.137A1.524,1.524,0,0,1,20.966,18.5l-7.615,9.137A1.523,1.523,0,0,1,12.181,28.181Zm12.183-1.523v1.523A1.522,1.522,0,0,1,22.842,29.7l-1.523,9.137H3.046L1.523,29.7A1.522,1.522,0,0,1,0,28.181V26.658a1.522,1.522,0,0,1,1.523-1.523h8.955l-.051.061a2.284,2.284,0,0,0,3.51,2.925l2.488-2.986h6.417A1.522,1.522,0,0,1,24.364,26.658ZM6.853,31.988a.761.761,0,0,0-1.523,0v4.568a.761.761,0,0,0,1.523,0Zm3.046,0a.761.761,0,0,0-1.523,0v4.568a.761.761,0,0,0,1.523,0Zm3.046,0a.761.761,0,0,0-1.523,0v4.568a.761.761,0,0,0,1.523,0Zm3.046,0a.761.761,0,0,0-1.523,0v4.568a.761.761,0,0,0,1.523,0Zm3.046,0a.761.761,0,1,0-1.523,0v4.568a.761.761,0,0,0,1.523,0Z",
    transform: "translate(0 -15.999)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvenience);
export default __webpack_public_path__ + "static/media/convenience.e3dc343eebf8cf451a953db018995c52.svg";
export { ForwardRef as ReactComponent };